import React, { FC, useState } from "react";
import FilterBtn from "./FilterBtn";
import Checkbox from "@mui/material/Checkbox";
import CardPagination from "./CardPagination";
import useTickets from "../../../../../store/ReactQueries/tickets/useTicket";
import LayoutSelect from "../../../Tickets/Components/TableForm/LayoutSelect";
import useAssets from "../../../../../store/ReactQueries/assets/asset/useAsset";
import { CardHeaderBtn } from "./CardHeaderBtn";
import { FormViewType } from "../../../Tickets/Tickets";
import { darkModeBackgroud } from "../../../../../utils/constants";
import { useDarkModeStore } from "../../../../../store/useDarkModeStore";

export type ModuleType = "Tickets" | "Assets";

interface CardHeaderProps {
  page: number;
  pageSize: number;
  module: ModuleType;
  arrayLength: number;
  selectedIds: string[];
  showFilters?: boolean;
  formView?: FormViewType;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
  setShowFilters?: React.Dispatch<React.SetStateAction<boolean>>;
  setFormView?: React.Dispatch<React.SetStateAction<FormViewType>>;
}

export const CardHeader: FC<CardHeaderProps> = ({
  module,
  page,
  pageSize,
  arrayLength,
  selectedIds,
  formView,
  showFilters,
  setPage,
  setPageSize,
  setSelectedIds,
  setFormView,
  setShowFilters,
}) => {
  const { darkMode } = useDarkModeStore();
  const { data: assets } = useAssets(page, pageSize);
  const { data: tickets } = useTickets(page, pageSize);

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setIsChecked(!isChecked);

    if (module === "Assets") {
      if (checked)
        setSelectedIds(assets?.map((asset) => asset.id).filter((id): id is string => id !== undefined) ?? []);
      else setSelectedIds([]);
    } else if (module === "Tickets" && tickets) {
      if (checked) setSelectedIds(tickets.map((asset) => asset.id).filter((id): id is string => id !== undefined));
      else setSelectedIds([]);
    } else setSelectedIds([]);
  };

  return (
    <div
      className="d-flex flex-row align-items-center gap-2 mb-2 card ps-3"
      style={{
        height: 80,
        background: darkMode ? darkModeBackgroud : "white",
      }}
    >
      <Checkbox checked={isChecked} onChange={handleChecked} style={{ color: darkMode ? "white" : "initial" }} />
      <CardHeaderBtn selectedIds={selectedIds} page={page} pageSize={pageSize} module={module} />
      {formView && setFormView && (
        <div className="w-100 p-2 d-flex align-items-center">
          <div className="ms-auto">
            <LayoutSelect size="small" formView={formView} setFormView={setFormView} module={module} />
          </div>
        </div>
      )}
      <CardPagination
        page={page}
        pageSize={pageSize}
        arrayLength={arrayLength}
        setPage={setPage}
        setPageSize={setPageSize}
      />

      {setShowFilters && <FilterBtn showFilters={showFilters ?? false} setShowFilters={setShowFilters} />}
    </div>
  );
};
export default CardHeader;
